import {
  Icon,
  Input,
  Select,
  Option,
  Table,
  TableColumn,
  Message,
  Autocomplete,
  Button,
  Form,
  FormItem,
  DatePicker,
  MessageBox
} from 'element-ui';

const element = {
  install: function (Vue) {
    Vue.use(Icon)
    Vue.use(Input)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Autocomplete)
    Vue.use(Button)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(DatePicker)
    Vue.prototype.$message = Message;
    Vue.prototype.$msgbox = MessageBox
  }
}

export default  element
